/** @format */

export const caculateVInvalid = (data, key: string) => {
  let result = 0;
  if (data?.length && key) {
    const rsTmp = data?.filter((e) => e?.result === key);
    return (result = rsTmp.length);
  }

  return result;
};
export const debounce = (func, timeout = 300) => {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(debounce, args);
    }, timeout);
  };
};

export const base64Image = (baseImg: string) =>
  `data:image/png;base64, ${baseImg}`;

export function sleep(n: number) {
  return new Promise((resolve) => setTimeout(resolve, n));
}

export const renderStatusBodyShape = (bmi: number) => {
  if (bmi < 18.5) return { title: "Under weight" };
  if (bmi >= 18.5 && bmi < 25) return { title: "Normal weight" };
  if (bmi >= 25 && bmi < 30) return { title: "Over weight" };
  if (bmi > 30) return { title: "Obesity" };
};

export const convertToNumber = (payment) => {
  return typeof payment === "string"
    ? Number(payment?.replace(/,/g, ""))
    : payment;
};

export const configHeader = {
  wrapText: true,
  headerHeight: 50,
  height: "100px",
  cellStyle: {
    whiteSpace: "normal",
    lineHeight: "1.5",
    textAlign: "left",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderRight: "1px solid #ccc",
  },
};

export const styleColRow = {
  borderRight: "1px solid #ddd",
  height: "30px",
  padding: "5px",
  textAlign: "center",
  fontSize: "14px",
  fontWeight: "500",
};

export const styleColHeader = {
  borderRight: "1px solid #ddd",
  height: "50px",
  padding: "5px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "rgba(0, 117, 208, 0.1)",
};

export const parseId = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === "") return undefined;
  const parsed = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const formatDate = (value?: string) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString("vi-VN");
};

export const compareDate = (filterDate: Date, cellValue?: string) => {
  if (!cellValue) return -1;
  const cellDate = new Date(cellValue);
  if (Number.isNaN(cellDate.getTime())) return 1;
  const cellOnly = new Date(
    cellDate.getFullYear(),
    cellDate.getMonth(),
    cellDate.getDate(),
  );
  if (cellOnly < filterDate) return -1;
  if (cellOnly > filterDate) return 1;
  return 0;
};

export const normalizeAttachments = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === "string" ? item : String(item ?? "")))
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed
          .map((item) => (typeof item === "string" ? item : String(item ?? "")))
          .map((item) => item.trim())
          .filter(Boolean);
      }
    } catch (error) {
      // ignore invalid JSON strings
    }
    return trimmed
      .split(/[,\n]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};

export const parseNumber = (value: unknown) => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const parsed = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
};

